import axios from '..'
import { store } from '../../redux'

export const getQuestionnaireUrl = () => {
  const dataStorageId = store.getState().storefront.id
  return axios
    .get(`transactions/${dataStorageId}/chi`)
    .then((response) => {
      return response.data
    })
}
